import React from 'react';
import '../HowItWorks/HowItWorks.css';
import './AboutHowWeWork.css';

const steps = [
  {
    number: '01',
    title: 'Your space comes first',
    description:
      'Before anything is designed or proposed, we take the time to understand how you live and what matters most to you. We study your property and listen so every recommendation is rooted in real needs.',
  },
  {
    number: '02',
    title: 'No surprises, at any stage',
    description:
      'We set clear expectations from the start. You know who is coming, when work happens, and what each phase includes. Every detail is transparent, so there is never confusion about pricing or what is being done.',
  },
  {
    number: '03',
    title: 'We see it through',
    description:
      'From first visit to final walk-through, we stay accountable to the same standards. We do not disappear after installation, and we do not cut corners. Your project is treated with long-term care in mind.',
  },
];

const AboutHowWeWork = () => (
  <section className="hiw hiw--about">
    <div className="hiw__inner">
      <div className="hiw__left">
        <span className="hiw__tag">WORKING WITH US</span>
        <h2 className="hiw__heading">
          What you can
          <span className="hiw__heading-accent"> count on</span>
        </h2>
        <p className="hiw__subtext">
          A few things have stayed consistent across every project we have served, and every client we have
          worked with.
        </p>
      </div>
      <div className="hiw__steps">
        {steps.map(step => (
          <div key={step.number} className="hiw__step">
            <span className="hiw__step-number">{step.number}</span>
            <div className="hiw__step-content">
              <h3 className="hiw__step-title">{step.title}</h3>
              <p className="hiw__step-desc">{step.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default AboutHowWeWork;
